export const TRADING_VIEW_WIDGET_ORIGIN = "https://www.tradingview-widget.com";

/** Warm DNS/TLS for TradingView iframe embeds before the chart mounts. */
export function preloadTradingViewScript(): void {
  if (typeof document === "undefined") return;

  if (!document.querySelector('link[data-tv-preconnect="widget"]')) {
    const preconnect = document.createElement("link");
    preconnect.rel = "preconnect";
    preconnect.href = TRADING_VIEW_WIDGET_ORIGIN;
    preconnect.crossOrigin = "anonymous";
    preconnect.dataset.tvPreconnect = "widget";
    document.head.appendChild(preconnect);
  }

  if (!document.querySelector('link[data-tv-dns="widget"]')) {
    const dnsPrefetch = document.createElement("link");
    dnsPrefetch.rel = "dns-prefetch";
    dnsPrefetch.href = TRADING_VIEW_WIDGET_ORIGIN;
    dnsPrefetch.dataset.tvDns = "widget";
    document.head.appendChild(dnsPrefetch);
  }
}

export function buildAdvancedChartEmbedUrl(tradingViewSymbol: string): string {
  const config = {
    allow_symbol_change: true,
    calendar: false,
    details: false,
    hide_side_toolbar: true,
    hide_top_toolbar: false,
    hide_legend: true,
    hide_volume: true,
    hotlist: false,
    interval: "D",
    locale: "en",
    save_image: true,
    style: "2",
    symbol: tradingViewSymbol,
    theme: "light",
    timezone: "Etc/UTC",
    backgroundColor: "#FFFFFF",
    gridColor: "rgba(46, 46, 46, 0.06)",
    watchlist: [],
    withdateranges: false,
    compareSymbols: [],
    studies: [],
    autosize: true,
  };

  return `${TRADING_VIEW_WIDGET_ORIGIN}/embed-widget/advanced-chart/?locale=en#${encodeURIComponent(JSON.stringify(config))}`;
}
